import { makeStyles, Theme } from "@material-ui/core";

export const Styles = makeStyles((theme: Theme) => ({
  app: {
    display: 'flex',
    flexDirection: 'column',
    width: "100%",
    overflow: "hidden",
    alignItems: "center",
    justifyContent: "center",
    "& img" : {
      marginBottom: "30px",
    },
    "& h3":{
      textAlign: "center",
      marginBottom: "10px",
    },
    "& h5":{
      textAlign: "center",
      marginBottom: "10px",
    },
    "& p":{
      textAlign: "center",
      marginBottom: "10px",
    }
  },
  defaultLayout : {
    width: "calc(100% - 18.57143rem) !important",
    "@media (max-width:1599.98px)": {
      width: "100% !important"
    }
  }
}));
